import axios from 'utils/requestHelper';

/* `per_page` is the caller's to set. It used to be pinned at 1000 here, so
   every visit to a parts screen pulled a thousand serialized parts - each with
   its models, brand, country and images - and handed the lot to the table in
   one go. The screens ask for a single page now. */
const fetchByFilters = (params) => axios.get('v1/clients/parts', { params });
const fetchPartsOnPromotions = (params) => axios.get('v1/clients/parts/promotions', { params });

const downloadParts = (params) =>
  axios.get(`v1/clients/parts/list_prices.${params.format}`, { params, responseType: 'blob' });

const fetchCount = () => axios.get('v1/clients/parts/count');

const PartsAPI = {
  fetchByFilters,
  downloadParts,
  fetchPartsOnPromotions,
  fetchCount,
};

export default PartsAPI;
